function imageLazyLoad() {
	const lazyImages = Array.from(document.querySelectorAll('img[data-src]'));

	setupIntersectionObserver(lazyImages);
}

export function setupIntersectionObserver(images) {
	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver(onIntersection);
		images.forEach(image => observer.observe(image));
	} else {
		loadImages(images);
	}
}

function onIntersection(entries, observer) {
	entries.forEach(entry => {
		if (entry.intersectionRatio > 0) {
			loadImage(entry.target);
			observer.unobserve(entry.target);
		}
	});
}

function loadImages(images) {
	images.forEach(loadImage);
}

function loadImage(image) {
	const sources = image.parentNode.querySelectorAll('source[data-srcset]');

	sources.forEach(sourceTag => {
		sourceTag.setAttribute('srcset', sourceTag.getAttribute('data-srcset'));
		sourceTag.removeAttribute('data-srcset');
	});

	if (image.getAttribute('data-src')) {
		image.setAttribute('src', image.getAttribute('data-src'));
	}

	image.onload = () => {
		image.removeAttribute('data-src');
	};
}

export default imageLazyLoad;
